import { type RootState } from "../types/reduxState";

const initialState: RootState = {
  app: {
    errorMessage: "",
    successMessage: "",
    applyBlocked: null,
    userRole: "admin",
    isAuthenticated: false,
    hobbies: [],
    languages: [],
    departments: [],
    designations: [],
    industries: [],
    boards: [],
    degrees: [],
    courseNames: [],
    courseSpecializations: [],
    toolsKnown: [],
    functions: [],
    skills: [],
    jobRoles: [],
    university: [],
    cities: [],
    hiringCompanies: [],
    userProfile: {},
    userPreference: {},
    userExeperience: [],
    userEducation: [],
    userCertificates: [],
    questions: [],
    personality: [],
    topicScore: [],
    scoreBand: [],
    perks: [],
    // prompts: {
    //   About: {
    //     questionId: 1,
    //     question: "about",
    //   },
    //   Work: {
    //     questionId: 2,
    //     question: "work",
    //   },
    // },
    prompts: {},
    videoQuestions: [],
    userVideos: [],
  },
  jobs: {
    skipped: [],
    shortlisted: [],
    listing: [],
    applied: [],
    jobDetails: {},
    jobSearchFilters: {
      type: "",
      company: [],
      function: [],
      jobRole: [],
      jobType: [],
      workMode: [],
      location: [],
      city: [],
      industry: [],
      minSal: null,
      maxSal: null,
      minExp: "",
      maxExp: "",
    },
  },
  b2b: {
    activeTab: 0,
    companyDetails: {},
    clientJobDetails: {},
    b2bJobDetails: {},
    b2bJobApplicants: {},
    applicantDetails: {},
    applicantDetailsLoading: false,
    personalities: [],
    functionPersonalities: [],
    comments: {},
    applicantReport: {},
    applicantPersonality: {},
    applicantTopicScore: {},
    applicantScoreBand: {},
    shareLinkValidation: {},
    sharePasswordValidation: {},
    orgAccountSettlements: {},
  },
  ajaxCallsInProgress: 0,
  companyList: {
    list: [],
    page: 1,
    totalCount: 0,
    rowsPerPage: 10,
    loading: false,
  },
  userList: {
    list: [],
    page: 1,
    totalCount: 0,
    rowsPerPage: 10,
    loading: false,
    companyList: [],
  },
};

export default initialState;
